<div class="brand-selection-container">
    <div class="buttons-container">
        @if (displayButtons && brands.length) {
            <button class="select-all" (click)="handleSelectAllClick()">Select All</button>
            <button class="deselect-all" (click)="handleDeselectAllClick()">Deselect All</button>
        }
    </div>
    <div class="brands-container">
        @for (brand of brands; track brand) {
            <div class="brand-tile" [class.selected]="brand.isSelected" (click)="handleBrandClick(brand)">
                <div class="brand-logo"><img [src]="brand.icon" (error)="onIconError($event)"></div>
                @if (brand.isSelected) {
                    <div class="checkmark">
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="5" viewBox="0 0 7 5" fill="none">
                            <path d="M5.90234 0.133201C6.10079 -0.0486617 6.41737 -0.0436643 6.60939 0.144303C6.80137 0.332294 6.79609 0.6322 6.59767 0.814104L2.72259 4.36664C2.62631 4.45487 2.49663 4.50295 2.36271 4.49986C2.22878 4.49676 2.10179 4.44257 2.01017 4.34999L0.135125 2.4553C-0.0536657 2.26445 -0.0433591 1.96486 0.158075 1.78596C0.359539 1.60712 0.675789 1.61688 0.864633 1.8077L2.39201 3.35084L5.90234 0.133201Z" fill="#4E5258"/>
                        </svg>
                    </div>
                }
            </div>
        }
    </div>
</div>